import { useFieldArray, useFormContext } from 'react-hook-form';
import { EnumSelectField } from '@mews-commander/form';
import { Card } from '@mews-commander/ui';
import {
    AccountingExportIntegrationExportAccountingSoftware,
    AccountingExportIntegrationExportTypes,
} from '@mews-commander/data-access';
import { FormInputField, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { CardContent, Title, Stack, StackItem } from '@optimus-web/core';
import { FieldNames } from './fieldNames';
import { AccountingExportConfigurationSchema } from './formProps';
import { ConfigurationDetailFormProps } from './ConfigurationDetailForm';

export const TaxAccountMappingList = ({ accountingSystemType }: ConfigurationDetailFormProps) => {
    const { control } = useFormContext<AccountingExportConfigurationSchema>();
    const { fields } = useFieldArray({ name: FieldNames.taxAccountMappings, control });

    return (
        <Card title={TextKey.TaxAccountMappings}>
            <CardContent padding="200">
                <Title level={2}>{lt('TaxAccountMappings')}</Title>
            </CardContent>
            <CardContent padding="200">
                <Stack vertical spacing="300">
                    {fields.map((field, index) => (
                        <Stack
                            key={field.id}
                            spacing="100"
                            distribution="stretch"
                            phoneOnly={{ vertical: true, spacing: '100' }}
                            largePhoneOnly={{ vertical: true, spacing: '100' }}
                            tabletOnly={{ vertical: true, spacing: '200' }}
                        >
                            <StackItem>
                                <FormInputField
                                    name={`${FieldNames.taxAccountMappings}.${index}.${FieldNames.taxCode}`}
                                    label={lt('TaxCode')}
                                    size="small"
                                    readOnly
                                />
                            </StackItem>
                            <StackItem>
                                <FormInputField
                                    name={`${FieldNames.taxAccountMappings}.${index}.${FieldNames.externalCode}`}
                                    label={lt('AccountingExportAccountCode')}
                                    size="small"
                                />
                            </StackItem>
                            {accountingSystemType === AccountingExportIntegrationExportAccountingSoftware.Avantage ? (
                                <StackItem>
                                    <EnumSelectField
                                        name={`${FieldNames.taxAccountMappings}.${index}.${FieldNames.exportType}`}
                                        label={lt('ExportType')}
                                        enumClass={AccountingExportIntegrationExportTypes}
                                        enumPrefix="ExportTypes"
                                        showEmptyValue
                                    />
                                </StackItem>
                            ) : null}
                        </Stack>
                    ))}
                </Stack>
            </CardContent>
        </Card>
    );
};
